import React from 'react'
import { TextFieldSeeker } from '@ui-seeker/core'
import { AppBulkEditAction, AppDialogCancel, AppModal } from '@components'
import { useSignal } from '@preact/signals-react'
import { BIOpenUrlModal } from 'Pages/BusinessLogistics/BI/Page/@signals'
import { useBIUrlModalSubmit } from 'Pages/BusinessLogistics/BI/Page/@hooks'


export default function BIUrlModal() {

	const urlName = useSignal('')
	const { isLoading, setIsLoading } = useBIUrlModalSubmit(urlName.value)


	return <AppModal
		isOpen={!!BIOpenUrlModal.value}
		controller={() => BIOpenUrlModal.value = null}
		containerProps={{ maxWidth: 'sm' }}
		icon="link"
		title="Url name"
		subtitle="Custom name for the saved url"
		footer={<>
			<AppDialogCancel onClick={() => BIOpenUrlModal.value = false}/>
			<AppBulkEditAction loading={isLoading} onClick={setIsLoading}>Confirm</AppBulkEditAction>
		</>}
	>
		<TextFieldSeeker
			label="Custom Name for the Url"
			value={urlName.value}
			onChange={e => urlName.value = e.target.value}
		/>
	</AppModal>
}